export const getIsLogged = ({ status } = {}) => status === 'LOGGED';

export const getIsPrime = ({ membership = {} } = {}) => {
  return membership && membership.status === 'ACTIVATED';
};

export const isLoading = ({ status = '' } = {}) =>
  status && status.toUpperCase() === 'LOADING';
